"use strict";
const createProps = () => (props) => Array.from(new Set(props));

export { createProps };
